import L from "leaflet";
import {Marker} from "react-leaflet";
import { Trafikkregulering } from "../../../services/RuteplanAPI";

import trafikkreguleringIconResource from "../../../assets/trafikkregulering.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const trafikkreguleringIcon = L.icon({
    iconUrl: trafikkreguleringIconResource,
    iconRetinaUrl: trafikkreguleringIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
});

export interface ITrafikkreguleringMarkersProps {
    trafikkreguleringer: Array<Trafikkregulering>;
}

export default function TrafikkreguleringMarkers (props: ITrafikkreguleringMarkersProps) {
    const {setClickedRoadFeature, setRoadFeatureDialogIsOpen} = useRouteFeatureDialogStoreActions();
    const {trafikkreguleringer} = props;

    return (
        <>
            {trafikkreguleringer && trafikkreguleringer.map((trafikkregulering: Trafikkregulering, index: number) => {
                return (
                    <Marker key={trafikkregulering.nvdbId + index}
                    position={[trafikkregulering.location!.y, trafikkregulering.location!.x]}
                    icon={trafikkreguleringIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(trafikkregulering);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                );
            })};
        </>
    );
}